import { useStaticQuery, graphql } from 'gatsby';

export const usePlaceholderImage = () => {
  return useStaticQuery(graphql`
    query {
      placeholder: file(relativePath: { eq: "PLACEHOLDER/PLACEHOLDER_GROUP.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, width: 300)
        }
      }
    }
  `).placeholder;
};
